export const ARRAY_ERROR = 'FINAL_FORM/array-error'
